import React from "react";
import { Link } from "react-router-dom";

export const ADMIN_ACTIVITY_LABELS = {
  oral_exam: "Oral Exam", dsa_interview: "DSA Interview", interview_practice: "Interview Practice",
  composition: "Composition", situational_writing: "Situational Writing", credit_purchase: "Credit Purchase",
  welcome_grant: "Welcome Grant", admin_adjustment: "Admin Adjustment", other: "Other",
};
export const ADMIN_SOURCE_LABELS = { subscription: "Subscription", promotional: "Promotional", paid: "Paid", mixed: "Mixed" };

export function formatAdminCreditDate(value, longDate = false) {
  const date = new Date(value);
  if (!value || Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("en-SG", longDate
    ? { day: "numeric", month: "long", year: "numeric" }
    : { day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit" }).format(date);
}

function signed(value) {
  const number = Number(value);
  if (!Number.isFinite(number) || number === 0) return "0";
  return number > 0 ? `+${number}` : `−${Math.abs(number)}`;
}

export default function AdminCreditEventsTable({ events = [], showUser = false, emptyMessage = "No credit activity matches these filters." }) {
  if (!events.length) return <div className="admin-meta">{emptyMessage}</div>;
  const usedKeys = new Set();
  return <div className="admin-table-scroll">
    <table className="admin-data-table">
      <thead><tr><th>Date</th>{showUser && <th>User</th>}<th>Activity</th><th>Type</th><th>Credit Source</th><th className="admin-number-cell">Change</th></tr></thead>
      <tbody>{events.map((event, index) => {
        const delta = Number(event.credit_delta) || 0;
        const typeLabel = ADMIN_ACTIVITY_LABELS[event.activity_type] || "Other";
        const compositeKey = [event.id, event.occurred_at, event.user_id, event.reference_id].filter(Boolean).join("|") || "credit-event";
        const rowKey = usedKeys.has(compositeKey) ? `${compositeKey}|${index}` : compositeKey;
        usedKeys.add(rowKey);
        return <tr key={rowKey}>
          <td>{formatAdminCreditDate(event.occurred_at)}</td>
          {showUser && <td className="admin-wrap-cell">
            <div>{event.user_email || event.user_id || "-"}</div>
            {event.user_email && event.user_id && <div className="admin-table-meta">{event.user_id}</div>}
            {event.user_id && <Link className="admin-table-link" to={`/admin/users?user_id=${encodeURIComponent(event.user_id)}`}>View User</Link>}
          </td>}
          <td className="admin-wrap-cell"><div>{event.activity_title || typeLabel}</div>{event.reference_id && <div className="admin-table-meta">{event.reference_id}</div>}</td>
          <td>{typeLabel}</td>
          <td>{ADMIN_SOURCE_LABELS[event.payment_source] || "Credits"}</td>
          <td className={`admin-number-cell ${delta > 0 ? "admin-credit-positive" : delta < 0 ? "admin-credit-negative" : ""}`}>{signed(event.credit_delta)}</td>
        </tr>;
      })}</tbody>
    </table>
  </div>;
}
